module.exports = __webpack_public_path__ + "img/06.56fa2af5.png";